import EmployeeManagementUpdate from '@components/file-update/employee-management';

const EmployeeManagementUpdatePage = () => {
  return <EmployeeManagementUpdate />;
};

export default EmployeeManagementUpdatePage;
